import { COUNTRIES, CURRENCIES_BY_COUNTRY, DEFAULT_COUNTRY, TIMEZONES_BY_COUNTRY } from '../constants/country';
import { Country } from '../types/commons';

import moment from './moment';
import 'moment-timezone';

let currentCountry: Country | undefined;

export const getCurrentCountry = () => currentCountry || DEFAULT_COUNTRY;

export const getCurrentCurrency = () => CURRENCIES_BY_COUNTRY[getCurrentCountry()];

/**
 * The backend sets the timezone depending on the country, we do the same here.
 */
export const getCurrentTimezone = () => TIMEZONES_BY_COUNTRY[getCurrentCountry()];

export const setCurrentCountry = (country?: Country) => {
  currentCountry = country;
  moment.tz.setDefault(getCurrentTimezone());
};

export const setDefaultCountry = () => {
  setCurrentCountry(DEFAULT_COUNTRY);
};

export const isCountryFR = () => getCurrentCountry() === COUNTRIES.FR;
export const isCountryGB = () => getCurrentCountry() === COUNTRIES.GB;
